var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_125_774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 311",
    d: "M5.92072 3.88614L3.24745 8.37129L0.871216 12.6485L1.34646 13.599L4.19795 14.5495L7.99993 15.0248L11.8019 14.5495L14.6534 13.599L15.1286 12.6485L12.5445 8.22277L10.2871 5.07426L7.76231 0.5L5.92072 3.88614Z",
    fill: "#00C2FF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 72",
    d: "M15.1039 12.6485C15.1039 12.8479 14.998 13.0977 14.6747 13.3843C14.3519 13.6704 13.8564 13.9509 13.2012 14.1967C11.8945 14.6867 10.0556 15 7.99996 15C5.94426 15 4.10546 14.6867 2.79871 14.1967C2.14349 13.9509 1.64798 13.6704 1.32526 13.3843C1.00195 13.0977 0.895996 12.8479 0.895996 12.6485C0.895996 12.4491 1.00195 12.1994 1.32526 11.9127C1.64798 11.6266 2.14349 11.3461 2.79871 11.1004C4.10546 10.6103 5.94426 10.297 7.99996 10.297C10.0556 10.297 11.8945 10.6103 13.2012 11.1004C13.8564 11.3461 14.3519 11.6266 14.6747 11.9127C14.998 12.1994 15.1039 12.4491 15.1039 12.6485Z",
    fill: "#00C2FF",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 309",
    d: "M0.915771 12.4554L7.76231 0.767326L15.047 12.3292",
    stroke: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_774"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCone);
export default __webpack_public_path__ + "static/media/cone.4b2b7bf6c3d510d2cb4d6715a8cdd2c7.svg";
export { ForwardRef as ReactComponent };